import React from 'react';

const Healthcare = () => {
  return (
    <div className="page">
      <h1>Healthcare Solutions</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default Healthcare; 